import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const Staff = withLazyFallback(() => import('components/Staff/Staff'));
const AdminBillingProvidersTable = withLazyFallback(
  () => import('components/admin/pages/Practices/Billing/AdminBillingProvidersTable')
);
const FacilityTable = withLazyFallback(
  () => import('components/admin/pages/Practices/Facility/FacilityTable')
);
const AdminFormBuilder = withLazyFallback(
  () => import('components/admin/pages/Practices/FormBuilder/AdminFormBuilder')
);
const AdminPracticesOrganization = withLazyFallback(
  () => import('components/admin/pages/Practices/Organization/Organization')
);
const PracticeOverviewContainer = withLazyFallback(
  () => import('components/admin/pages/Practices/OverviewContainer')
);
const PatientImport = withLazyFallback(
  () => import('components/admin/pages/Practices/PatientImport')
);
const PracticePatients = withLazyFallback(
  () => import('components/admin/pages/Practices/Patients/Patients')
);
const PracticesTable = withLazyFallback(
  () => import('components/admin/pages/Practices/PracticesTable')
);
const Settings = withLazyFallback(
  () => import('components/admin/pages/Practices/Settings/Settings')
);
const CheckInStepsSettings = withLazyFallback(
  () => import('components/admin/pages/Practices/Settings/components/CheckInSteps')
);
const ClinicalNotesSettings = withLazyFallback(
  () => import('components/admin/pages/Practices/Settings/components/ClinicalNotes')
);
const FormsSettings = withLazyFallback(
  () => import('components/admin/pages/Practices/Settings/components/Forms')
);
const PatientCommunicationSettings = withLazyFallback(
  () => import('components/admin/pages/Practices/Settings/components/PatientCommunication')
);
const SelfSchedulingSettings = withLazyFallback(
  () => import('components/admin/pages/Practices/Settings/components/SelfScheduling')
);
const TerminalManagement = withLazyFallback(
  () => import('components/admin/pages/Practices/Terminals/TerminalManagement')
);
const AdminPracticesTransactions = withLazyFallback(
  () => import('components/admin/pages/Practices/Transaction/Transactions')
);
const AdminForms = withLazyFallback(() => import('components/admin/pages/Practices/forms'));
const EditFormBuilderContainer = withLazyFallback(
  () => import('components/admin/pages/Practices/forms/FormEditContainer')
);
const NewFormBuilderContainer = withLazyFallback(
  () => import('components/admin/pages/Practices/forms/new_container')
);
const PracticeProfile = withLazyFallback(() => import('components/admin/pages/Practices/profile'));
const AdminStaff = withLazyFallback(() => import('components/admin/pages/Practices/staff'));
const KioskSettings = withLazyFallback(
  () => import('components/practice/Settings/components/Kiosks/KioskSettings')
);
const Roles = withLazyFallback(() => import('components/Roles/Roles'));

const ADMIN_PRACTICES = [
  {
    path: 'practices',
    element: <PracticesTable />,
    children: [
      {
        path: ':id',
        element: <PracticeProfile />,
        children: [
          { path: '', element: <PracticeOverviewContainer /> },
          { path: 'staff', element: <AdminStaff /> },
          { path: 'patients', element: <PracticePatients /> },
          {
            path: 'forms',
            element: <AdminForms />,
            children: [
              { path: 'create', element: <NewFormBuilderContainer /> },
              { path: 'edit/:formId', element: <EditFormBuilderContainer /> },
              { path: '*', element: <NotFound /> }
            ]
          },
          {
            path: 'settings',
            element: <Settings />,
            children: [
              { path: 'forms', element: <FormsSettings /> },
              { path: 'patient-communication', element: <PatientCommunicationSettings /> },
              { path: 'clinical-notes', element: <ClinicalNotesSettings /> },
              { path: 'check-in-steps', element: <CheckInStepsSettings /> },
              { path: 'self-scheduling-steps', element: <SelfSchedulingSettings /> }
            ]
          },
          { path: 'terminals', element: <TerminalManagement /> },
          { path: 'roles', element: <Roles isAdmin /> },
          { path: 'staff-management', element: <Staff /> },
          { path: 'kiosk', element: <KioskSettings /> },
          { path: 'patient-import', element: <PatientImport /> },
          { path: 'billing', element: <AdminBillingProvidersTable /> },
          { path: 'facility', element: <FacilityTable /> },
          { path: 'transactions', element: <AdminPracticesTransactions /> },
          { path: 'organization', element: <AdminPracticesOrganization /> },
          { path: 'form-builder', element: <AdminFormBuilder /> },
          { path: '*', element: <NotFound /> }
        ]
      },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default ADMIN_PRACTICES;
